import { request } from "../utils/request";
import { ref, watch } from "@vue/composition-api";

const defaultConfig = {
  initQuery: {
    page_size: 10,
    page: 1,
  },
  api: "",
  auto: true,
  resetDataBeforeRequest: false,
};

export const useFetchList = (config) => {
  const conf = Object.assign(defaultConfig, config);

  const isLoading = ref("false");
  const isError = ref(false);
  const data = ref([]);
  const error = ref(null);
  const query = ref(conf.initQuery);
  const count = ref(0);

  query.value.page = conf.ctx.root.$route.query.page || 1;

  const fetchData = () => {
    isLoading.value = true;
    conf.resetDataBeforeRequest && (data.value = []);
    request
      .get(conf.api, { params: query.value })
      .then((resp) => {
        if (resp.data) {
          data.value = resp.data.results;
          count.value = resp.data.pages;
          error.value = null;
          isError.value = false;
        } else {
          data.value = [];
          error.value = new Error({ message: "请求结果错误" });
          isError.value = true;
        }
      })
      .catch((error) => {
        error.value = error;
        isError.value = true;
      })

      .finally(() => {
        isLoading.value = false;
      });
  };

  const handlePageChange = (page) =>
    conf.ctx.root.$router.push({ query: { page: page } });

  watch(
    () => conf.ctx.root.$route.query,
    () => {
      query.value.page = Number(conf.ctx.root.$route.query.page || 1);
      fetchData();
    }
  );

  conf.auto && fetchData();

  return {
    fetchData,
    isLoading,
    data,
    error,
    query: query.value,
    count,
    handlePageChange,
  };
};
